import { useState } from "react";
//import PropagateLoader from "react-spinners/PropagateLoader";
import { ClipLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function CommonLoader() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#55c7ff");

  return (
    <div className="sweet-loading">
      <ClipLoader
        color={color}
        loading={loading}
        size={50}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}
// function CommonLoadernew() {
//   return (
//     <div className="sweet-loading">
//       <PropagateLoader
//         color={color}
//         loading={loading}
//         size={15}
//         aria-label="Loading Spinner"
//         data-testid="loader"
//       />
//     </div>
//   );
// }

export default CommonLoader;
